import { renderCallback } from "./blueprint";
export function renderComponent(component) {
    return {
        instanceCallbacks: [
            renderCallback(function () { return component; }),
        ],
    };
}
export default renderComponent;

//# sourceMappingURL=renderComponent.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/renderComponent.js
// module id = 18
// module chunks = 0